var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.counter !== 0)?_c('b-button',{staticClass:"mr-2",attrs:{"variant":_vm.color,"disabled":!_vm.enabled},on:{"click":function($event){return _vm.$emit('filter-activated')}}},[_vm._v("\n  "+_vm._s(_vm.statusName)+" ("+_vm._s(_vm.counter)+")\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }